<div *ngIf="isLoading">
    <ng-content select="[skeleton]"></ng-content>
    <ng-content select="nz-skeleton"></ng-content>
</div>
<div [hidden]="isLoading">
    <ng-content select="[content]"></ng-content>
</div>
